// GENERATED by theme-presets.generate.ts — do not edit by hand (EPD-10132).
// Portfolio theme presets, curated from the tweakcn registry (colours converted
// OKLCH -> hex). Re-run (formats itself with prettier, so the committed file is
// byte-stable): bun run apps/app/lib/portfolio/theme-presets.generate.ts

export const PORTFOLIO_THEME_IDS = [
  "default",
  "amber-minimal",
  "modern-minimal",
  "clean-slate",
  "mono",
  "graphite",
  "nature",
  "ocean-breeze",
  "sage-garden",
  "pastel-dreams",
  "vintage-paper",
  "elegant-luxury",
  "sunset-horizon",
  "mocha-mousse",
  "cosmic-night",
  "midnight-bloom",
] as const;

export type PortfolioThemeId = (typeof PORTFOLIO_THEME_IDS)[number];

export interface PresetMeta {
  id: PortfolioThemeId;
  label: string;
  blurb: string;
}

export interface PresetColors {
  bg: string;
  surface: string;
  text: string;
  headingColor: string;
  mutedText: string;
  border: string;
  accent: string;
  accentText: string;
  heroSolid: string;
  fontHeading: string;
  fontBody: string;
}

export const PORTFOLIO_THEME_META: Record<PortfolioThemeId, PresetMeta> = {
  default: { id: "default", label: "Default", blurb: "Aspire clean · Inter" },
  "amber-minimal": {
    id: "amber-minimal",
    label: "Amber",
    blurb: "Warm amber · minimal",
  },
  "modern-minimal": {
    id: "modern-minimal",
    label: "Modern",
    blurb: "Clean & modern",
  },
  "clean-slate": { id: "clean-slate", label: "Slate", blurb: "Cool neutral" },
  mono: { id: "mono", label: "Mono", blurb: "Monochrome" },
  graphite: { id: "graphite", label: "Graphite", blurb: "Soft greyscale" },
  nature: { id: "nature", label: "Nature", blurb: "Forest green" },
  "ocean-breeze": { id: "ocean-breeze", label: "Ocean", blurb: "Fresh green" },
  "sage-garden": { id: "sage-garden", label: "Sage", blurb: "Muted sage" },
  "pastel-dreams": {
    id: "pastel-dreams",
    label: "Pastel",
    blurb: "Soft pastel",
  },
  "vintage-paper": {
    id: "vintage-paper",
    label: "Vintage",
    blurb: "Warm paper",
  },
  "elegant-luxury": {
    id: "elegant-luxury",
    label: "Luxury",
    blurb: "Deep & refined",
  },
  "sunset-horizon": {
    id: "sunset-horizon",
    label: "Sunset",
    blurb: "Warm sunset",
  },
  "mocha-mousse": { id: "mocha-mousse", label: "Mocha", blurb: "Mocha brown" },
  "cosmic-night": { id: "cosmic-night", label: "Cosmic", blurb: "Dark indigo" },
  "midnight-bloom": {
    id: "midnight-bloom",
    label: "Midnight",
    blurb: "Dark plum",
  },
};

export const PRESET_COLORS: Record<PortfolioThemeId, PresetColors> = {
  default: {
    bg: "#FFFFFF",
    surface: "#FAFAF7",
    text: "#0F1311",
    headingColor: "#0F1311",
    mutedText: "#73726E",
    border: "#E8E5DD",
    accent: "#1E4945",
    accentText: "#FFFFFF",
    heroSolid: "#FAFAF7",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
  "amber-minimal": {
    bg: "#FFFFFF",
    surface: "#F9FAFB",
    text: "#262626",
    headingColor: "#262626",
    mutedText: "#6B7280",
    border: "#E5E7EB",
    accent: "#F59E0B",
    accentText: "#0F1311",
    heroSolid: "#F9FAFB",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
  "modern-minimal": {
    bg: "#FFFFFF",
    surface: "#F9FAFB",
    text: "#333333",
    headingColor: "#333333",
    mutedText: "#6B7280",
    border: "#E5E7EB",
    accent: "#3B82F6",
    accentText: "#0F1311",
    heroSolid: "#F9FAFB",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
  "clean-slate": {
    bg: "#F8FAFC",
    surface: "#F3F4F6",
    text: "#1E293B",
    headingColor: "#1E293B",
    mutedText: "#6B7280",
    border: "#D1D5DB",
    accent: "#6366F1",
    accentText: "#000000",
    heroSolid: "#F3F4F6",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
  mono: {
    bg: "#FFFFFF",
    surface: "#F5F5F5",
    text: "#0A0A0A",
    headingColor: "#0A0A0A",
    mutedText: "#717171",
    border: "#E5E5E5",
    accent: "#737373",
    accentText: "#FFFFFF",
    heroSolid: "#F5F5F5",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
  graphite: {
    bg: "#F0F0F0",
    surface: "#D9D9D9",
    text: "#333333",
    headingColor: "#333333",
    mutedText: "#666666",
    border: "#D0D0D0",
    accent: "#606060",
    accentText: "#FFFFFF",
    heroSolid: "#D9D9D9",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
  nature: {
    bg: "#F8F5F0",
    surface: "#F0E9E0",
    text: "#3E2723",
    headingColor: "#3E2723",
    mutedText: "#6D4C41",
    border: "#E0D6C9",
    accent: "#2E7D32",
    accentText: "#FFFFFF",
    heroSolid: "#F0E9E0",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
  "ocean-breeze": {
    bg: "#F0F8FF",
    surface: "#F3F4F6",
    text: "#374151",
    headingColor: "#374151",
    mutedText: "#6B7280",
    border: "#E5E7EB",
    accent: "#22C55E",
    accentText: "#0F1311",
    heroSolid: "#F3F4F6",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
  "sage-garden": {
    bg: "#F8F7F4",
    surface: "#FFFFFF",
    text: "#1A1F2E",
    headingColor: "#1A1F2E",
    mutedText: "#6B7280",
    border: "#E8E6E1",
    accent: "#7C9082",
    accentText: "#0F1311",
    heroSolid: "#FFFFFF",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
  "pastel-dreams": {
    bg: "#F7F3F9",
    surface: "#F3E8FF",
    text: "#374151",
    headingColor: "#374151",
    mutedText: "#6B7280",
    border: "#E9D8FD",
    accent: "#A78BFA",
    accentText: "#0F1311",
    heroSolid: "#F3E8FF",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
  "vintage-paper": {
    bg: "#F5F1E6",
    surface: "#ECE5D8",
    text: "#4A3F35",
    headingColor: "#4A3F35",
    mutedText: "#7D6B56",
    border: "#DBD0BA",
    accent: "#A67C52",
    accentText: "#0F1311",
    heroSolid: "#ECE5D8",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
  "elegant-luxury": {
    bg: "#FAF7F5",
    surface: "#F0EBE8",
    text: "#1A1A1A",
    headingColor: "#1A1A1A",
    mutedText: "#57534E",
    border: "#F5E8D2",
    accent: "#9B2C2C",
    accentText: "#FFFFFF",
    heroSolid: "#F0EBE8",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
  "sunset-horizon": {
    bg: "#FFF9F5",
    surface: "#FFF0EB",
    text: "#3D3436",
    headingColor: "#3D3436",
    mutedText: "#78716C",
    border: "#FFE0D6",
    accent: "#FF7E5F",
    accentText: "#0F1311",
    heroSolid: "#FFF0EB",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
  "mocha-mousse": {
    bg: "#F1F0E5",
    surface: "#E4C7B8",
    text: "#56453F",
    headingColor: "#56453F",
    mutedText: "#8A655A",
    border: "#BAAB92",
    accent: "#A37764",
    accentText: "#0F1311",
    heroSolid: "#E4C7B8",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
  "cosmic-night": {
    bg: "#0F0F1A",
    surface: "#222244",
    text: "#E2E2F5",
    headingColor: "#E2E2F5",
    mutedText: "#A0A0C0",
    border: "#303052",
    accent: "#A48FFF",
    accentText: "#0F1311",
    heroSolid: "#222244",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
  "midnight-bloom": {
    bg: "#1A1D23",
    surface: "#2F3436",
    text: "#E5E5E5",
    headingColor: "#E5E5E5",
    mutedText: "#A3A3A3",
    border: "#444444",
    accent: "#6C5CE7",
    accentText: "#FFFFFF",
    heroSolid: "#2F3436",
    fontHeading: "'Playfair Display', Georgia, serif",
    fontBody: "'Inter', system-ui, sans-serif",
  },
};
